import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch6_p13 } from "../../../layouts/ch6_p13/ch6_p13";

export class Chapter6Page13 extends AbstractStoryState implements ReturnType<typeof ch6_p13> {

    readonly bg = this.addChild(new SceneSprite());
    readonly horse = this.addChild(new SceneSprite());
    readonly tylerHolly = this.addChild(new SceneSprite());
    readonly rain = [this.addChild(SceneSprite.withPrefix("ch6_p13/")), this.addChild(SceneSprite.withPrefix("ch6_p13/"))];
    readonly sparkles = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch6_p13/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch6_p13/"));
    readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch6_p13/"));
    readonly linesRight = this.addChild(SceneSprite.withPrefix("ch6_p13/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch6_p13.call(this);

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();

        TweenLite.delayedCall(1.5, ()=>{
            this.gotoNextState({transition: "left"});
        });
    }

}